<template>
  <div class="about">
    hi
    <services />
    <accomodation />
  </div>
</template>

<script>
import Services from '@/components/Services.vue'
import Accomodation from '@/components/Accommodation.vue'
export default {
  name: 'home', 
  components: {
    Services,
    Accomodation
  }
}
</script>